export default __webpack_public_path__ + "static/media/id-card.ef438ee6.png";